import { render } from "./PasswordResetRequest.vue?vue&type=template&id=1ac81e35&scoped=true"
import script from "./PasswordResetRequest.vue?vue&type=script&lang=js"
export * from "./PasswordResetRequest.vue?vue&type=script&lang=js"

import "./PasswordResetRequest.vue?vue&type=style&index=0&id=1ac81e35&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1ac81e35"
/* hot reload */
if (module.hot) {
  script.__hmrId = "1ac81e35"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1ac81e35', script)) {
    api.reload('1ac81e35', script)
  }
  
  module.hot.accept("./PasswordResetRequest.vue?vue&type=template&id=1ac81e35&scoped=true", () => {
    api.rerender('1ac81e35', render)
  })

}

script.__file = "src/views/PasswordResetRequest.vue"

export default script